// composables/useLoading.ts
export const useLoading = () => {
  const isLoading = useState<boolean>('loading', () => false)

  const show = () => {
    isLoading.value = true
  }

  const hide = () => {
    isLoading.value = false
  }

  return {
    isLoading,
    show,
    hide,
  }
}
